<template>
    <v-card>
        <v-card-title class="font-italic grey--text darken-3 text-uppercase">{{ $t('notes') }}</v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" md="6">
                    <v-textarea
                        v-model="data.message"
                        outlined
                        :label="$t('message')"
                        color="teal lighten-2"
                    ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                    <v-textarea
                        v-model="data.comment"
                        outlined
                        :label="$t('comments')"
                        color="teal lighten-2"
                    ></v-textarea>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    import { MixinOrderInfo } from '../../../mixins';

    export default {
        name: 'NotesInfo',
        mixins: [MixinOrderInfo],
        data() {
            return {
                key: 'notesInfo',
            }
        },
        methods: {
            orderHandle(value) {
                const { message, comment } = value;
                this.data = {
                    message, comment,
                }
            },
        },
    }
</script>

<style scoped>

</style>
